import {
  LoanApplication,
  type PROJECT_TYPE,
} from '../../../../../../../modules/loan';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { projectType } = loanFormModel.formField;

/** True when `project_type` is set and is Solar or Solar+ (LoanApplication.isSolar). */
class IsApplicationSolar implements Rule {
  public evaluate(data: Partial<ApplicationFormValues>): boolean {
    const pt = data[projectType.name];
    if (!pt) return false;
    return LoanApplication.isSolar(pt as PROJECT_TYPE);
  }
}

export default new IsApplicationSolar();
